export const CREATE_SUBSIDIARY_DIALOG_STEPS = Object.freeze({
  accountInfo: 0,
  bankInfo: 1,
  completed: 2,
} satisfies Record<string, number>);

export type CreateSubsidiaryDialogStep =
  (typeof CREATE_SUBSIDIARY_DIALOG_STEPS)[keyof typeof CREATE_SUBSIDIARY_DIALOG_STEPS];
